import styled from "styled-components";

const StyledButton = styled.div`
  border-radius: 20px;
  border: solid 1px #e6e8f0;
  background: transparent;
  padding: 8px 16px;
  display: flex;
  align-items: center;
  justify-content: space-between;
  min-width: max-content;
  cursor: pointer;
`;

const Label = styled.div`
  display: flex;
  flex-direction: column;
  align-items: flex-start;
  justify-content: flex-start;
  margin-right: 8px;
`;

const Title = styled.div`
  font-size: 10px;
  font-weight: 500;
  line-height: 1;
  color: #6f7582;
`;

const Description = styled.div`
  font-size: 14px;
  font-weight: bold;
  line-height: 1.14;
  color: #222939;

  ::first-letter {
    text-transform: capitalize;
  }
`;

const Icon = styled.img``;

export { StyledButton, Label, Title, Description, Icon };



// WEBPACK FOOTER //
// ./src/newDropshipperApp/pages/search/SortByStyle.js